/**
 * @todo Удалить после завершения эксперимента
 * @description Данный функционал появился в задаче CD-253017, будет удалён в задаче CD-253242
 */
export const SNR_DESKTOP_SR135_REMOVE_POPULAR = 'snr_desktop_sr135_remove_popular';

export const EXPERIMENTS = [SNR_DESKTOP_SR135_REMOVE_POPULAR];
